/**
 * Export all available plugins
 */
export { ImageProxyPlugin } from './image-proxy/index.js';
export { LazyLoadingPlugin } from './lazy-loading/index.js';
export { CLSPreventionPlugin } from './cls-prevention/index.js';
export { ResourceHintsPlugin } from './resource-hints/index.js';
// Build-time plugin registry with static imports
// Plugins are executed in the order they appear in this array
import { ResourceHintsPlugin } from './resource-hints/index.js';
import { ImageProxyPlugin } from './image-proxy/index.js';
import { CLSPreventionPlugin } from './cls-prevention/index.js';
import { LazyLoadingPlugin } from './lazy-loading/index.js';
/**
 * Plugin execution order (build-time determined)
 *
 * 1. ResourceHintsPlugin: Must run first to establish connections and preloads
 * 2. ImageProxyPlugin: Process images early, affects LCP
 * 3. CLSPreventionPlugin: Apply layout stability after images are processed
 * 4. LazyLoadingPlugin: Apply lazy loading last, after all other optimizations
 */
export const PLUGIN_REGISTRY = [
    ResourceHintsPlugin,
    ImageProxyPlugin,
    CLSPreventionPlugin,
    LazyLoadingPlugin
];
/**
 * Map plugin names to classes
 */
export const PLUGIN_CLASS_MAP = {
    ResourceHintsPlugin,
    ImageProxyPlugin,
    CLSPreventionPlugin,
    LazyLoadingPlugin
};
// Legacy compatibility - remove after migration
export const pluginMap = {
    ImageProxyPlugin: () => Promise.resolve(ImageProxyPlugin),
    LazyLoadingPlugin: () => Promise.resolve(LazyLoadingPlugin),
    CLSPreventionPlugin: () => Promise.resolve(CLSPreventionPlugin),
    ResourceHintsPlugin: () => Promise.resolve(ResourceHintsPlugin),
};
//# sourceMappingURL=index.js.map